import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { Grid, GridColumn } from '@atlaskit/page';
import { ViewTracker } from '@atlassian/jira-analytics-web-react';
import { BreadcrumbRenderer } from '@atlassian/jira-breadcrumbs/src';
import { injectIntlV2 as injectIntl, type IntlShapeV2 as IntlShape } from '@atlassian/jira-intl';
import { SCREEN, type AnalyticsAttributes } from '@atlassian/jira-product-analytics-bridge';

import errorImage from '@atlassian/jira-servicedesk-common/src/utils/assets/error.svg';
import type { GenericError } from '@atlassian/jira-servicedesk-knowledge-services/src/types';
import { LinkComponent as Link } from '@atlassian/jira-servicedesk-spa-commons';

import MessageCallToAction from '../message-call-to-action';
import PageHeader from '../page-header';

export type Props = GenericError & {
	screenName: string;
	attributes?: AnalyticsAttributes;
};

type ErrorPageProps = Props & {
	intl: IntlShape;
};

export function ErrorPage(props: ErrorPageProps) {
	const { intl, error, screenName, attributes } = props;

	return (
		<AnalyticsContext
			data={{
				source: `${screenName}${SCREEN}`,
				attributes: attributes ? { ...attributes } : {},
			}}
		>
			<Grid>
				<GridColumn>
					{/* @ts-expect-error - TS2769 - No overload matches this call. */}
					<PageHeader truncateTitle breadcrumbs={<BreadcrumbRenderer />} />
					<ViewTracker />

					<MessageCallToAction
						imageUrl={errorImage}
						header={intl.formatMessage(error.header)}
						description={intl.formatMessage(error.message)}
						primaryAction={
							error.ctaLink && error.ctaText ? (
								<Link to={error.ctaLink || ''}>{intl.formatMessage(error.ctaText)}</Link>
							) : undefined
						}
					/>
				</GridColumn>
			</Grid>
		</AnalyticsContext>
	);
}

export default injectIntl(ErrorPage);
